import Consents from './Consents'
export default Consents
